import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "test-questions" }
const _hoisted_2 = { class: "img" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]

import { ref, inject, toRefs } from "vue"
import { examKey } from "@/main";
import { Page } from "@/store/exam";

interface Props {
  question: Page
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Layout1',
  props: {
    question: null
  },
  setup(__props: any) {

const props = __props as {
  question: Page
};

const exam = inject(examKey);



const { question } = toRefs(props);
const image = ref<string>();

const init = async () => {
  if (!question.value.image) return;
  const questions = await exam?.questions();
  image.value = questions?.images[question.value.image];
}
init();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (image.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: image.value,
              alt: ""
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      (_unref(question).example)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "test-hint",
            innerHTML: _unref(question).questions[0].explanation
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})